export default {
      id: "system-plus-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#system-plus-usage",
      toString: function () {
        return this.url;
      }
    }